import useOtsReporting from './UseOtsReporting';

import ReportList from '@usas/ui-web/components/embeddedReports/ReportList';

const OtsReporting = () => {
  const { reportParameters, routeName } = useOtsReporting();

  return (
    <ReportList listTitle="OTS Reports"
      routeName={routeName}
      reportParameters={reportParameters} />
  );
};

export default OtsReporting;